import { api } from '@/api/api-client.config.ts';
import { PageType } from '@/@types/api.types.ts';
import { useMutation } from '@tanstack/react-query';

const createPage = (page: PageType) => api.post(`/admin/pages/`, page);

export const useCreatePageMutation = () => {
  return useMutation({
    mutationKey: ['createPage'],
    mutationFn: createPage,
  });
};
